// Timing and units shared by client and server. Change these only together with PROTOCOL_VERSION.

/** Bump whenever a message shape or a rule the client predicts changes. Old clients are told to refresh. */
export const PROTOCOL_VERSION = 9;

/** Simulation ticks per second. Movement, dash and attack timers all count in ticks. */
export const SIM_HZ = 60;
export const TICK_MS = 1000 / SIM_HZ;

/** A snapshot goes out every N ticks (60 / 3 = 20 per second). */
export const SNAPSHOT_EVERY = 3;

/** The client sends its inputs every N ticks, repeating the last INPUT_REDUNDANCY of them so a lost packet costs nothing. */
export const INPUT_SEND_EVERY = 2;
export const INPUT_REDUNDANCY = 8;

/** Positions are whole numbers of 1/SUB pixel, so client and server always compute identical results. */
export const SUB = 64;

/** Heartbeats: the client pings every PING_MS; the server drops a connection silent for TIMEOUT_MS. */
export const PING_MS = 2000;
export const TIMEOUT_MS = 10000;

/** A dropped player can reconnect as the same character within this window. */
export const RESUME_GRACE_MS = 30000;

/** Hard limits that protect the server. */
export const LIMITS = {
  maxMessageBytes: 4096,
  nameMax: 16,
  chatMax: 120,
  chatBurst: 5,          // messages
  chatWindowMs: 5000,    // per window
  inputMsgsPerSecond: 90,
  inputQueueMax: 120,   // 2 s of inputs: a phone that stalls for a second loses nothing
} as const;

/** Interest management: who sees what. Distances in tiles. */
export const AOI = {
  cellTiles: 8,          // spatial grid cell size
  viewTiles: 26,         // entities further than this (Chebyshev) are not sent
  nearTiles: 14,         // within this, every snapshot; beyond, every FAR_EVERY snapshots
  farEvery: 3,
  maxEntitiesPerSnapshot: 160,
  sayTiles: 20,          // /say reaches this far
} as const;
